import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  children?: React.ReactNode;
}

const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ size = 'lg', padding = 'md', className, children, ...props }, ref) => {
    const sizeClasses = {
      sm: 'max-w-2xl',
      md: 'max-w-4xl',
      lg: 'max-w-6xl',
      xl: 'max-w-7xl',
      full: 'max-w-full',
    };

    const paddingClasses = {
      none: '',
      sm: 'px-4',
      md: 'px-6',
      lg: 'px-8',
    };

    return (
      <div
        ref={ref}
        className={cn('mx-auto w-full', sizeClasses[size], paddingClasses[padding], className)}
        {...props}
      >
        {children}
      </div>
    );
  },
);

Container.displayName = 'Container';

export { Container };
